"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentUsernameLogin = void 0;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _loginForm = require("../../schoolUiComponents/loginForm");
var _state = require("../../authSignin/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StudentUsernameLogin = exports.StudentUsernameLogin = function StudentUsernameLogin() {
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    sendEvent = _useAuthSigninState.sendEvent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-username-login",
    "data-sentry-component": "StudentUsernameLogin",
    "data-sentry-source-file": "usernameLogin.tsx"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back dark",
    onClick: function onClick() {
      return window.location.hash = "";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })), /*#__PURE__*/_react["default"].createElement("h4", null, "Student Log In"), /*#__PURE__*/_react["default"].createElement(_loginForm.LoginForm, {
    showOTPLoginOption: false,
    primaryInputLabel: "Username",
    showForgotPassword: false,
    source: "Class Login",
    showSocialLogin: false,
    sendEvent: sendEvent,
    "data-sentry-element": "LoginForm",
    "data-sentry-source-file": "usernameLogin.tsx"
  }));
};